<div [formGroup]="form" class="informate_select_wrapper">
    <mat-label class="font-style" [ngbTooltip]="sealRingMaterial_toolTip" placement="right" container="body" tooltipClass="small-tooltip">
        <!-- Seal Ring Material -->
        {{ 'CLAMP_PAGE.LABELS.CALC_INPUT.SEAL_RING_MATERIAL' | transloco }}
    </mat-label>
    <!--tool-tip template start-->
    <ng-template #sealRingMaterial_toolTip>
        <p>
            {{ 'TOOLTIP.INFORMATE_CALC_LABELS.SEAL_RING_MATERIAL' | transloco }}
        </p>
    </ng-template>
    <!--tool-tip template end-->
    <mat-select
        formControlName="sealRingMaterial"
        name="sealRingMaterial"
        class="input-select"
        [class.spinner]="loading"
        [class.select-disable]="enable"
        (selectionChange)="selectSealRingMaterial($event)"
    >
        <mat-option class="option-list" *ngFor="let x of optionList" [value]="x.sealRingMaterialId">{{ x.name }}</mat-option>
    </mat-select>
</div>
